import { Header } from "../../../../src/components/common/header";
import { KSACookiePolicyEn } from "../../../../src/components/cookie-policy/ksa/en";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  Header,
  KSACookiePolicyEn,
  Footer,
  React
};